import {
  Card,
  Collection,
  Divider,
  Flex,
  Grid,
  Heading,
  View,
  Text,
  ScrollView,
} from "@aws-amplify/ui-react";
import React from "react";
import { ResultAnalytics } from "../types/ResultAnalytics";
import { Player } from "../../game/Types/GameTypes_dep";

export default function GradeSummary({
  analytics,
  players,
}: {
  analytics: ResultAnalytics;
  players: Player[];
}) {
  const { highScorers, midScorers, lowScorers } = analytics;

  const highScorerNicknames = players
    .filter((player) => highScorers.some((scorer) => scorer === player.groupId))
    .map((player) => player.nickname);

  const midScorerNicknames = players
    .filter((player) => midScorers.some((scorer) => scorer === player.groupId))
    .map((player) => player.nickname);

  const lowScorerNicknames = players
    .filter((player) => lowScorers.some((scorer) => scorer === player.groupId))
    .map((player) => player.nickname);

  return (
    <>
      <Card boxShadow={"large"}>
        <Heading paddingBottom={"xs"}>Grade Summary</Heading>
        <ScrollView>
          <Grid
            templateColumns={"1fr 1fr 1fr"}
            textAlign={"center"}
            height={"300px"}
          >
            <View>
              <Text
                padding={"xxxs"}
                fontSize={{ base: "small", medium: "large" }}
                fontWeight={"bold"}
                color={"red.60"}
              >
                0-50%
              </Text>
              <Divider
                style={{ borderColor: "var(--amplify-colors-neutral-40)" }}
              />

              {lowScorerNicknames && (
                <Collection
                  items={lowScorerNicknames}
                  searchNoResultsFound={"-"}
                  type="grid"
                  templateColumns={{ base: "1fr", medium: "1fr 1fr" }}
                  padding={"small"}
                  gap={"small"}
                >
                  {(nickname) => (
                    <Flex
                      key={nickname}
                      justifyContent={"center"}
                      borderRadius={"xxl"}
                      id="raised-item"
                      color={"white"}
                      backgroundColor={"red.60"}
                      // style={{ border: "2px solid var(--amplify-colors-red-80)" }}
                      alignItems={"center"}
                      padding={"xs"}
                      grow={1}
                      fontWeight={"semibold"}
                    >
                      <Text isTruncated color={"inherit"}>
                        {nickname}
                      </Text>
                    </Flex>
                  )}
                </Collection>
              )}
            </View>
            <View
              boxShadow={
                "-2px 0px 0px 0px var(--amplify-colors-neutral-40), 2px 0px 0px 0px var(--amplify-colors-neutral-40)"
              }
            >
              <Text
                padding={"xxxs"}
                fontSize={{ base: "small", medium: "large" }}
                fontWeight={"bold"}
                color={"orange.60"}
              >
                50-80%
              </Text>
              <Divider
                style={{ borderColor: "var(--amplify-colors-neutral-40)" }}
              />
              {midScorerNicknames && (
                <Collection
                  items={midScorerNicknames}
                  searchNoResultsFound={"-"}
                  type="grid"
                  templateColumns={{ base: "1fr", medium: "1fr 1fr" }}
                  padding={"small"}
                  gap={"small"}
                >
                  {(nickname) => (
                    <View key={nickname}>
                      {nickname && (
                        <Flex
                          justifyContent={"center"}
                          color="white"
                          borderRadius={"xxl"}
                          backgroundColor={"orange.60"}
                          id="raised-item"
                          // border={"yellow.60"}
                          // style={{ border: "2px solid var(--amplify-colors-orange-80)" }}
                          // color={'white'}
                          // backgroundColor={'yellow.80'}
                          alignItems={"center"}
                          padding={"xs"}
                          grow={1}
                          fontWeight={"semibold"}
                        >
                          <Text isTruncated color={"inherit"}>
                            {nickname}
                          </Text>
                        </Flex>
                      )}
                    </View>
                  )}
                </Collection>
              )}
            </View>
            <View>
              <Text
                padding={"xxxs"}
                fontSize={{ base: "small", medium: "large" }}
                fontWeight={"bold"}
                color={"green.80"}
              >
                {" "}
                80-100%
              </Text>
              <Divider
                style={{ borderColor: "var(--amplify-colors-neutral-40)" }}
              />
              {highScorerNicknames && (
                <Collection
                  items={highScorerNicknames}
                  searchNoResultsFound={"-"}
                  type="grid"
                  templateColumns={{ base: "1fr", medium: "1fr 1fr" }}
                  padding={"small"}
                  gap={"small"}
                >
                  {(nickname) => (
                    <View key={nickname}>
                      {nickname && (
                        <Flex
                          justifyContent={"center"}
                          borderRadius={"xxl"}
                          color={"white"}
                          id="raised-item"
                          backgroundColor={"green.80"}
                          // style={{ border: "2px solid var(--amplify-colors-green-100)" }}
                          alignItems={"center"}
                          padding={"xs"}
                          grow={1}
                          fontWeight={"semibold"}
                        >
                          <Text isTruncated color={"inherit"}>
                            {nickname}
                          </Text>
                        </Flex>
                      )}
                    </View>
                  )}
                </Collection>
              )}
            </View>
          </Grid>
        </ScrollView>
      </Card>
    </>
  );
}
